//changed due to package upgrade
import React, { useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import IntlMessages from '@projectK/helpers/IntlMessages';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import "react-quill-new/dist/quill.snow.css";  // import styles
import { alpha, Grid, Modal } from '@mui/material';
import { Form, Formik } from 'formik';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import jwtAxios from '@projectK/services/auth/JWT';
import { useDropzone } from 'react-dropzone';
import AppGrid from '@projectK/components/AppGrid';
import PreviewThumb from '../../../thirdParty/reactDropzone/components/PreviewThumb';
import UploadModern from '../../../thirdParty/reactDropzone/components/UploadModern';
import Cropper from 'react-easy-crop';
import PropTypes from 'prop-types';
export async function getCroppedImg(imageSrc, pixelCrop) {
  const image = new Image();
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height,
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Canvas is empty'));
          return;
        }

        const file = new File([blob], 'cropped.jpg', { type: 'image/jpeg' });
        resolve(file);
      }, 'image/jpeg');
    };

    image.onerror = reject;
  });
}
function InlineCropper({ open, image, aspect, onComplete, onCancel }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [pixelCrop, setPixelCrop] = useState(null);

  const handleDone = async () => {
    if (!pixelCrop) return;
    const croppedImage = await getCroppedImg(image, pixelCrop);
    onComplete(croppedImage);
  };

  return (
    <Modal open={open} onClose={onCancel}>
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '88%',
          maxWidth: 420,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography
          variant='h6'
          sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}
        >
          Do you want to crop this image?
        </Typography>

        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: 300,
            background: '#333',
            borderRadius: 1,
            overflow: 'hidden',
          }}
        >
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(_, croppedAreaPixels) =>
              setPixelCrop(croppedAreaPixels)
            }
          />
          <input
            type='range'
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            style={{
              position: 'absolute',
              bottom: 10,
              left: 10,
              width: 150,
              zIndex: 10,
            }}
          />
        </Box>
        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
          }}
        >
          <Button
            variant='outlined'
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
          >
            Cancel
          </Button>

          <Button
            variant='contained'
            onClick={(e) => {
              e.stopPropagation();
              handleDone();
            }}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
const ImageUpload = (props) => {
  const { isOpen, onClose, product_Id, settings, fetchData, selectedTheme } =
    props;
  const infoViewActionsContext = useInfoViewActionsContext();
  const editorRef = useRef(null);
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.getContent(); // Get content when needed
    }
  }, []);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [cropperOpen, setCropperOpen] = useState(false);
  const [fileToCrop, setFileToCrop] = useState(null);
  const dropzone = useDropzone({
    accept: {
      'image/png': ['.png', '.jpeg', '.jpg'],
    },
    onDrop: (acceptedFiles) => {
      // Append new files to the existing uploadedFiles array
      setUploadedFiles((prevFiles) => [
        ...prevFiles,
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      ]);
      const file = acceptedFiles[0];
      setFileToCrop(URL.createObjectURL(file));
      setCropperOpen(true);
    },
  });

  useEffect(() => {
    setUploadedFiles(dropzone.acceptedFiles);
  }, [dropzone.acceptedFiles]);
  const handleCroppedImage = (croppedFile) => {
    setUploadedFiles([
      { preview: URL.createObjectURL(croppedFile), file: croppedFile },
    ]);
    setCropperOpen(false);
    setFileToCrop(null);
  };

  const handleCropperCancel = () => {
    setCropperOpen(false);
    setUploadedFiles([]);
    setFileToCrop(null);
  };
  const onDeleteUploadFile = (file) => {
    dropzone.acceptedFiles.splice(dropzone.acceptedFiles.indexOf(file), 1);
    setUploadedFiles([...dropzone.acceptedFiles]);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        className='p-popup'
        sx={{
          bgcolor: 'background.paper',
        }}
      >
        <Formik
          initialValues={{
            product_tagline: settings?.product_tagline || null,
            show_tagline_products_page: Boolean(
              settings?.show_tagline_products_page,
            ),
            show_in_products_page: Boolean(settings?.show_in_products_page),
            product_description: settings?.product_description || null,
            short_description: settings?.short_description || null,
            badge: settings?.badge || null,
            product_theme: settings?.product_theme || null,
            product_image: settings?.product_image || null,
          }}
          //   validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);

            let imageUrl;

            if (uploadedFiles && uploadedFiles.length > 0) {
              const file = uploadedFiles[0]?.file || uploadedFiles[0];
              const formData = new FormData();
              formData.append('file', file);

              try {
                const response = await jwtAxios.post(`/fileuploads`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                });
                const bgFileName = await response.data;
                imageUrl = bgFileName.file;
              } catch (error) {
                imageUrl = null;
                console.error(
                  'Error uploading file: ',
                  error.message ||
                    error.data.message ||
                    error.data.error ||
                    error,
                );
              }

              const updatedValues = {
                ...values,
                ...(imageUrl && { product_image: imageUrl }),
              };

              await jwtAxios
                .put(`/product-display-settings/${product_Id}`, updatedValues)
                .then((response) => {
                  setSubmitting(false);
                  fetchData();
                  onClose();
                  infoViewActionsContext.showMessage(
                    'Image Updated successfully!',
                  );
                })
                .catch((error) => {
                  infoViewActionsContext.fetchError(error.message);
                  setSubmitting(false);
                });
            }
          }}
        >
          {({ touched, errors }) => (
            <Form autoComplete='off'>
              <Grid size={{ xs: 12, md: 12 }}>
                <Typography
                  variant='h5'
                  style={{
                    marginBottom: '20px',
                    color: selectedTheme
                      ? selectedTheme.primary.main
                      : 'text.primary',
                  }}
                >
                  Upload Image
                </Typography>
                <UploadModern
                  uploadText='Drag n drop some files here, or click to select files'
                  setUploadedFiles={setUploadedFiles}
                  dropzone={dropzone}
                />
                <Typography sx={{ mt: '5px' }}>
                  <span style={{ fontWeight: 'bold' }}>Note:</span>
                  Image dimensions are {`750 × 316`}
                </Typography>
                {touched.product_image && !uploadedFiles.length ? (
                  <div
                    className='error'
                    style={{
                      color: '#d32f2f',
                      fontSize: '13px',
                      marginLeft: '13px',
                      marginTop: '6px',
                    }}
                  >
                    {errors.product_image}
                  </div>
                ) : (
                  delete errors.product_image
                )}
                <AppGrid
                  sx={{
                    maxWidth: 500,
                  }}
                  data={uploadedFiles}
                  column={4}
                  itemPadding={5}
                  renderRow={(file, index) => (
                    <PreviewThumb
                      file={file}
                      onDeleteUploadFile={onDeleteUploadFile}
                      key={index + file.path}
                    />
                  )}
                />
              </Grid>
              {cropperOpen && fileToCrop && (
                <InlineCropper
                  open={cropperOpen}
                  image={fileToCrop}
                  aspect={375 / 158}
                  onComplete={handleCroppedImage}
                  onCancel={handleCropperCancel}
                />
              )}
              <Grid size={{ xs: 12, md: 12 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '10px',
                  }}
                >
                  <Button
                    sx={{
                      position: 'relative',
                      minWidth: 100,
                      backgroundColor: selectedTheme
                        ? selectedTheme.primary.main
                        : '#2196f3',
                      '&:hover': {
                        backgroundColor: selectedTheme
                          ? alpha(selectedTheme.primary.main, 0.8) // Adjust the alpha value as needed
                          : alpha('#2196f3', 0.8),
                      },
                    }}
                    variant='contained'
                    type='submit'
                  >
                    <IntlMessages id='common.save' />
                  </Button>
                  <Button
                    sx={{
                      position: 'relative',
                      minWidth: 100,
                      ml: 2.5,
                      borderColor: selectedTheme
                        ? selectedTheme.primary.main
                        : '#2196f3',
                      '&:hover': {
                        borderColor: selectedTheme
                          ? alpha(selectedTheme.primary.main, 0.8)
                          : alpha('#2196f3', 0.8),
                      },
                      color: selectedTheme
                        ? selectedTheme.primary.main
                        : '#2196f3',
                    }}
                    variant='outlined'
                    onClick={onClose}
                    type='cancel'
                  >
                    <IntlMessages id='common.cancel' />
                  </Button>
                </Box>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
ImageUpload.propTypes = {
  product_Id: PropTypes.number,
  onClose: PropTypes.func,
  fetchData: PropTypes.func,
  selectedTheme: PropTypes.object,
  settings: PropTypes.object,
  isOpen: PropTypes.bool,
};
InlineCropper.propTypes = {
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
  open: PropTypes.bool,
  image: PropTypes.string,
  aspect: PropTypes.number.isRequired,
};
export default ImageUpload;
